import { motion } from "framer-motion";

interface ReactionSplashProps {
  text: string;
}

export function ReactionSplash({ text }: ReactionSplashProps) {
  return (
    <motion.div
      key={text}
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: [0, 1, 1, 0], scale: [0.6, 1, 1, 0.95] }}
      transition={{ duration: 1.2, times: [0, 0.25, 0.75, 1], ease: "easeOut" }}
      className="absolute inset-0 z-30 flex items-center justify-center bg-background/80 backdrop-blur-sm pointer-events-none"
      aria-live="polite"
    >
      <span className="font-heading font-black text-3xl sm:text-4xl text-primary text-center px-6">
        {text}
      </span>
    </motion.div>
  );
}
